export default {
  orderNumber: {
    id: 'diagnosis_orderline_recap_order_number',
    defaultMessage: 'Order # {orderId}',
  },
  errorMessage: {
    id: 'diagnosis_orderline_recap_error_message',
    defaultMessage:
      "We're having trouble loading your item details. Don't worry — you can still continue with your request.",
  },
}
